import React from 'react';

interface ImportAllConfirmModalProps {
  isOpen: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
}

const ImportAllConfirmModal: React.FC<ImportAllConfirmModalProps> = ({ 
  isOpen, 
  count, 
  onClose, 
  onConfirm 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200">
      <div 
        className="bg-[#1c1c1e] border border-gray-800 w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200"
      >
        <div className="p-6 text-center">
          {/* Warning Icon */}
          <div className="w-16 h-16 bg-red-500/10 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl border border-red-500/20">
            ⚠️
          </div>

          {/* Text Content */}
          <h3 className="text-xl font-bold text-white mb-2">ยืนยัน Import ทั้งหมด</h3>
          <p className="text-gray-400 text-sm mb-6 leading-relaxed">
            แผนเทรดที่คุณเคยตีไว้ในหุ้นทั้ง <span className="text-white font-bold px-1">{count} รายการ</span> จะถูกลบและแทนที่ด้วยเส้นของ <span className="text-yellow-400 font-bold">แอดอั้ม</span> ทันที
          </p>

          {/* Action Buttons */}
          <div className="grid grid-cols-1 gap-3">
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="w-full py-3 bg-red-600 hover:bg-red-500 text-white rounded-xl font-bold text-sm transition-all active:scale-95 shadow-lg shadow-red-600/20 flex items-center justify-center gap-2"
            >
              🚀 ยืนยันและแทนที่ข้อมูล
            </button>

            <button
              onClick={onClose}
              className="w-full py-3 bg-[#2c2c2e] hover:bg-[#3a3a3c] text-white rounded-xl font-bold text-sm transition-all active:scale-95 border border-gray-700"
            >
              ยกเลิก
            </button>
          </div>
          
          <p className="text-[10px] text-gray-600 mt-4 uppercase tracking-widest font-bold">
            Action cannot be undone
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImportAllConfirmModal;